export const carouselSlotsBaseItemSpacing = "0.75rem";
export const carouselSlotsBaseGradientMask = "linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5) 21%, rgba(0, 0, 0, 1) 25%, rgba(0, 0, 0, 1) 75%, rgba(0, 0, 0, 0.5) 79%, rgba(0, 0, 0, 0))";
export const carouselSlotsLayout = "layout-col";
export const carouselSlotsLeftButtonPosition = "relative";
export const carouselSlotsLeftButtonStyle = "outlined";
export const carouselSlotsLeftButtonSize = "sm";
export const carouselSlotsLeftButtonGlyph = "chevron_left";
export const carouselSlotsRightButtonPosition = "relative";
export const carouselSlotsRightButtonStyle = "outlined";
export const carouselSlotsRightButtonSize = "sm";
export const carouselSlotsRightButtonGlyph = "chevron_right";
